import { api } from './api';

export interface PerfilAcesso {
  id: string;
  name: string;
  normalizedName?: string;
  concurrencyStamp?: string;
}

export interface PerfilAcessoDetalhes {
  idRole: string;
  role: string;
  menus: Array<{
    idMenu: number;
    menu: string;
  }>;
}

export const perfilAcessoService = {
  getAll: async (): Promise<PerfilAcesso[]> => {
    const response = await api.get<PerfilAcesso[]>('/api/PerfisAcesso/GetAll');
    console.log('Resposta da API getAll:', response.data);
    return response.data;
  },

  getById: async (id: string): Promise<PerfilAcessoDetalhes> => {
    const response = await api.get<PerfilAcessoDetalhes>(`/api/PerfisAcesso/GetById?id=${id}`);
    console.log('Resposta da API getById:', response.data);
    return response.data;
  },

  getByIdParaEditar: async (id: string): Promise<PerfilAcesso> => {
    const response = await api.get<PerfilAcesso>(`/api/PerfisAcesso/GetByIdParaEditar?id=${id}`);
    return response.data;
  },

  getMenusSelect: async (): Promise<any[]> => {
    const response = await api.get<any[]>('/api/PerfisAcesso/GetMenusSelect');
    return response.data;
  },

  salvar: async (perfil: any): Promise<PerfilAcesso> => {
    const response = await api.post<PerfilAcesso>('/api/PerfisAcesso/Salvar', perfil);
    return response.data;
  }
};
